import React from "react";
import { cn } from "@/lib/utils";

/* PageContainer — the shared mobile-first page wrapper (PREMIUM_UI_DIRECTION §4.1).
   16px gutters on mobile, section rhythm, max-width desktop column, and bottom padding
   so content clears the fixed bottom nav + the device safe-area. Use on every customer
   surface so every page shares the same gutters and rhythm.

   Props:
   - gutters (default true): apply px-4 / sm:px-6 / lg:px-8 horizontal gutters.
   - rhythm (default true): apply the vertical section rhythm (space-y-6 / lg:space-y-8).
   - clearBottomNav (default true): pad the bottom so the last section clears the mobile
     bottom tab bar (the shell already pads <main>, but a page that renders its own
     sticky footer can opt out).
   - className: extra classes merged last. */
export default function PageContainer({
  children,
  gutters = true,
  rhythm = true,
  clearBottomNav = false,
  className,
  ...rest
}) {
  return (
    <div
      className={cn(
        "mx-auto w-full max-w-[1200px]",
        gutters && "px-4 py-6 sm:px-6 lg:px-8 lg:py-8",
        rhythm && "space-y-6 lg:space-y-8",
        clearBottomNav && "pb-[calc(76px+env(safe-area-inset-bottom))] lg:pb-0",
        className
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
